module.exports = "/_next/static/images/construction-29bf959e715bab949d6b59ea866d5c54.png.webp";